module.exports = __webpack_public_path__ + "static/sebrene-4f510f38c8dbe72c8baff1f0c71e83cd.jpg";